import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import './styles.css'
import './company-about.css'
import './footer.css'
import './office-map.css'
import './liquid-glass.css'
import './portfolio.css'
import './office-map-click.css'
import './payekooh-phone.css'
import './start-project.css'
import './bazaar-showcase.css'
import './workflow-process.css'
import './dot-grid-warp.css'
import './services-redesign.css'
import './effects/dotGridWarp.js'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
